export default __webpack_public_path__ + "static/media/laptop-membership.76448110.png";